import { truncate } from "../../libraries/utils";
const d = document;
const $page = d.querySelector(".page-comunicacion-divulgacion");


if ($page) {
  const $sliders = $page.querySelectorAll(".external-links");
  const sliderClassJS = ['js-slider-publications', 'js-slider-video', 'js-slider-podcast'];
  const sliderClassType = ['slider-publications', 'slider-video', 'slider-podcast'];
  let contador = 0;

  $sliders.forEach((slide) => {
    slide.classList.remove("external-links");
    slide.classList.add("slider");
    slide.classList.add(sliderClassType[contador]);
    const JS = slide.querySelector('.js-external-link-slider');
    JS.classList.remove("js-external-link-slider");
    JS.classList.add(sliderClassJS[contador]);
    contador++;
  });
}

document.addEventListener("DOMContentLoaded", ()=> {
  const $textSliders = $('.title-link-externo');

  $textSliders.each(function () {
    let textSliderTempo = $(this).text();
    $(this).text(truncate(textSliderTempo, 75));
  });
});
